/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { Screen, Title, Subtitle } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
import { Reviews } from '../_shared/Reviews';

const REVIEWS = ['keysi', 'maria', 'taty'];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-women-social-proof' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-women-social-proof' });
    onNext();
  };

  return (
    <Screen
      progress={46}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={<PrimaryButton onClick={next}>{t('hairstyleWomenSocialProof.cta')}</PrimaryButton>}
    >
      <Title>{t('hairstyleWomenSocialProof.title')}</Title>
      <Subtitle>{t('hairstyleWomenSocialProof.subtitle')}</Subtitle>
      <div style={{ marginTop: 24 }}>
        <Reviews ns="hairstyleWomenSocialProof" ids={REVIEWS} />
      </div>
    </Screen>
  );
}

export default Page;
